import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useCallback, useReducer } from 'react';
import { setRuntimeConfig } from '@/lib/agencySlug';
// Начальное состояние
const initialState = {
    config: null,
    isLoading: false,
    error: null,
    isInitialized: false,
};
// Reducer для управления состоянием конфига
const configReducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_START':
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case 'LOAD_SUCCESS':
            return {
                ...state,
                isLoading: false,
                config: action.payload,
                error: null,
                isInitialized: true,
            };
        case 'LOAD_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                isInitialized: true,
            };
        case 'RESET':
            return initialState;
        default:
            return state;
    }
};
// Создание контекста
const ConfigContext = createContext(undefined);
export const ConfigProvider = ({ children, loadConfigFn }) => {
    const [state, dispatch] = useReducer(configReducer, initialState);
    const loadConfig = useCallback(async () => {
        dispatch({ type: 'LOAD_START' });
        try {
            const config = await loadConfigFn();
            setRuntimeConfig(config);
            dispatch({ type: 'LOAD_SUCCESS', payload: config });
        }
        catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Неизвестная ошибка при загрузке конфига';
            dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
        }
    }, [loadConfigFn]);
    const resetConfig = useCallback(() => {
        setRuntimeConfig(null);
        dispatch({ type: 'RESET' });
    }, []);
    const contextValue = {
        ...state,
        loadConfig,
        resetConfig,
    };
    return (_jsx(ConfigContext.Provider, { value: contextValue, children: children }));
};
// Хук для использования контекста
export const useConfigContext = () => {
    const context = useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('useConfigContext должен использоваться внутри ConfigProvider');
    }
    return context;
};
